import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocaleService } from '../services/locale.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleInterceptor implements HttpInterceptor {
  private localeService = inject(LocaleService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'Accept-Language': this.localeService.locale(),
      },
    });

    return next.handle(request);
  }
}
